module.exports = __webpack_public_path__ + "img/sponsorC23.6900b950.png";